import { render, staticRenderFns } from "./mc-count-status-button.tests.vue?vue&type=template&id=563bf261&scoped=true"
import script from "./mc-count-status-button.tests.vue?vue&type=script&lang=ts"
export * from "./mc-count-status-button.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bf261",
  null
  
)

export default component.exports